import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d061fa34b9ae001446571e/labcallmanager/src/app/referrals/page.tsx");
